var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',{staticClass:"select-row"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"row__content"},_vm._l((_vm.data),function(item,index){return _c('span',{key:index,staticClass:"select-btn",on:{"click":function($event){return _vm.handleClick({ type: _vm.type, data: item }, $event)}}},[[_vm._v(_vm._s(item.name))]],2)}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79dc8824","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/SearchPage/components/SelectRow.vue
// module id = 1254
// module chunks = 1